import { useState } from 'react';

import useStudent from 'store/student/useStudent';
import { setCookie } from 'utils/cookie';
import useUser from 'store/user/useUser';

import {
  Dialog,
  Typography,
  Button,
  FormControlLabel,
  Checkbox,
  Stack,
  Grid,
  useTheme,
} from '@mui/material';

import { ReactComponent as Number01 } from 'assets/icon-number-01.svg';
import { ReactComponent as Number02 } from 'assets/icon-number-02.svg';
import { ReactComponent as Number03 } from 'assets/icon-number-03.svg';
import { ReactComponent as Number04 } from 'assets/icon-number-04.svg';
import { ReactComponent as Number05 } from 'assets/icon-number-05.svg';

export interface SimpleDialogProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  setShow: (show: boolean) => void;
}

function Introduction(props: SimpleDialogProps) {
  const { palette } = useTheme();
  const { open, setOpen, setShow } = props;
  // const { student_name } = useStudent();

  const {
    student_name,
    student_uuid,
    student_grade,
    college_ci,
    college_name,
  } = useUser();

  const contents = [
    {
      title: 'Nền tảng',
      desc1: 'SMARTYURSE ENR là một hệ thống hồ sơ điều dưỡng điện ',
      desc2: 'tử thực tế được tạo ra cho sinh viên điều dưỡng và y tá mới.',
      desc3: '',
      desc4: '',
      desc5: '',
    },
    {
      title: 'Giải pháp của chúng tôi',
      desc1: "Vì vậy, chúng tôi đã tạo ra 'Smart Nurse ENR' để giúp y tá",
      desc2: 'đang gặp khó khăn có thể thực hành chuẩn bị hồ sơ điều',
      desc3: 'dưỡng từ căn bản đến nâng cao.',
      desc4: '',
      desc5: '',
    },
    {
      title: 'Bối cảnh',
      desc1: 'Hiện tại, 100% bệnh viện đa khoa sử dụng EMR (hồ sơ y tế điện',
      desc2: 'tử) và theo báo cáo, các y tá dành 35% thời gian làm việc để',
      desc3: 'chuẩn bị hồ sơ điều dưỡng.',
      desc4: '',
      desc5: '',
    },
    {
      title: 'Tính khả thi',
      desc1: "'Smart Nurse ENR' là một hệ thống hồ sơ điều dưỡng điện tử ",
      desc2: 'sử dụng công nghệ điện toán đám mây giúp cho y tá và sinh',
      desc3: 'viên có thể sử dụng bất cứ lúc nào, bất cứ nơi đâu như PC, Mac, ',
      desc4: 'iPad hoặc trên bất kỳ điện thoại thông minh nào, mà không ',
      desc5: 'cần cài đặt riêng.',
    },
    {
      title: 'Vấn đề hiện nay',
      desc1: 'Hầu hết các y tá mới đều gặp khó khăn trong quá trình chuẩn',
      desc2: 'bị hồ sơ điều dưỡng.',
      desc3: '',
      desc4: '',
      desc5: '',
    },
  ];

  const icons = [
    <Number01 fill={'#2D73DC'} />,
    <Number04 fill={'#2D73DC'} />,
    <Number02 fill={'#2D73DC'} />,
    <Number05 fill={'#2D73DC'} />,
    <Number03 fill={'#2D73DC'} />,
  ];

  /* 다시 보지 않기 체크박스 관련 */
  const [check, setCheck] = useState(false);
  /*************************/

  return (
    <Dialog
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            maxWidth: '75%',
            padding: '50px 100px',
            backgroundColor: palette.mode === 'dark' ? 'grey' : '',
          },
        },
      }}
      onClose={() => setOpen(false)}
      open={open}
    >
      <Stack direction="row">
        <Typography
          sx={{ fontWeight: '700', fontSize: '64px', lineHeight: '80px' }}
        >
          Chào mừng,
        </Typography>
        <Typography
          sx={{
            color: '#2D73DC',
            fontWeight: '700',
            fontSize: '64px',
            lineHeight: '80px',
          }}
        >
          {student_name}
        </Typography>
      </Stack>
      <Typography
        sx={{ fontWeight: '700', fontSize: '64px', lineHeight: '80px' }}
      >
        Đây là SMARTNURSE ENR :)
      </Typography>
      <Typography
        sx={{
          color: '#2D73DC',
          fontWeight: '700',
          fontSize: '30px',
          lineHeight: '50px',
        }}
      >
        Hãy cùng thực hành hồ sơ điều dưỡng nhé?
      </Typography>
      {/* <Button
        sx={{
          width: '187px',
          height: '48px',
          color: 'white',
          backgroundColor : '#2D73DC',
color: '#E7EFFF',
          marginTop: '15px',
          whiteSpace: 'nowrap',
        }}
        variant="contained"
        onClick={() => {
          setShow(true);
          setOpen(false);
        }}
      >
        Tap to keep watching
      </Button> */}
      <Grid
        container
        columnSpacing={10}
        rowSpacing={5}
        marginTop="62px"
        marginBottom="45px"
      >
        {contents.map(({ title, desc1, desc2, desc3 }, idx) => (
          <Grid item xs={6}>
            <Stack
              direction="row"
              spacing={2}
              alignItems="center"
              marginBottom="20px"
            >
              {icons[idx]}
              <Typography
                sx={{
                  color: '#2D73DC',
                  fontWeight: '700',
                  fontSize: '40px',
                  lineHeight: '50px',
                }}
              >
                {title}
              </Typography>
            </Stack>
            <Typography sx={{ whiteSpace: 'nowrap' }}>
              {desc1}
              <br />
              {desc2}
              <br />
              {desc3}
            </Typography>
          </Grid>
        ))}
      </Grid>
      <Stack direction="row" spacing={2}>
        <Button
          sx={{
            width: '187px',
            height: '48px',
            color: '#2D73DC',
            backgroundColor: 'white',
            border: '3px solid #2D73DC',
          }}
          variant="outlined"
          onClick={() => {
            if (check) setCookie('no_intro', 'true', 30);
            setShow(false);
            setOpen(false);
          }}
        >
          Nhấn để đóng
        </Button>
        <FormControlLabel
          control={
            <Checkbox
              value={check}
              onChange={e => setCheck(e.target.checked)}
            />
          }
          // label="Do not open for a month"
          label="Không hiện lại trong 1 tháng"
        />
      </Stack>
    </Dialog>
  );
}

export default Introduction;
